/** Mirrors API `JobTitle` constants (Sales AI agent customization). */
export const JOB_TITLE_SALES_DEVELOPMENT_REPRESENTATIVE = "Sales development representative";
export const JOB_TITLE_BUSINESS_DEVELOPMENT_REPRESENTATIVE = "Business development representative";
export const JOB_TITLE_ACCOUNT_EXECUTIVE = "Account executive";
export const JOB_TITLE_ACCOUNT_MANAGER_CUSTOMER_SUCCESS = "Account Manager / Customer Success";
export const JOB_TITLE_SALES_OPS = "Sales ops";
export const JOB_TITLE_PARTNERSHIP_MANAGER = "Partnership manager";
export const JOB_TITLE_OTHER = "Other (specify)";

export const JOB_TITLE_OPTIONS: readonly string[] = [
    JOB_TITLE_SALES_DEVELOPMENT_REPRESENTATIVE,
    JOB_TITLE_BUSINESS_DEVELOPMENT_REPRESENTATIVE,
    JOB_TITLE_ACCOUNT_EXECUTIVE,
    JOB_TITLE_ACCOUNT_MANAGER_CUSTOMER_SUCCESS,
    JOB_TITLE_SALES_OPS,
    JOB_TITLE_PARTNERSHIP_MANAGER,
    JOB_TITLE_OTHER,
];

export const ROLES_OTHER_OPTION = JOB_TITLE_OTHER;
